import React from 'react';
import { Link } from 'react-router-dom';

function Contact() {
  return (
    <div className="App-header">
      <h1>Contact Us</h1>
      <p>For support or inquiries, please email us at:</p>
      <a href="mailto:support@optipathway.com">support@optipathway.com</a>
      <br />
      <br />
      <Link to="/">Back to Optimizer</Link>
    </div>
  );
}

export default Contact;
